// /gatsby-browser.js

require('typeface-inter'); // Load Inter typeface
require('./src/styles/main.scss')
